import { ENTITY_TAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "Entity Id",
    hide: true,
    field: "entityId",
  },
  {
    headerName: "Entity Name",
    field: "entityName",
    width: 380,
  },
  {
    headerName: "Category",
    field: "categoryName",
    width: 130,
  },
  // {
  //   headerName: "Entity Identifier",
  //   field: "entityIdentifier",
  //   width: 150,
  // },
  // {
  //   headerName: "Parent",
  //   field: "entityData",
  //   width: 150,
  // },
  {
    headerName: "Entity Type",
    field: "type",
    width: 120,
  },
  {
    headerName: "Contact Number",
    field: "contactNumber",
    width: 100,
  },
  {
    headerName: "Phone/Landline Number",
    field: "landlineNumber",
    width: 150,
  },
  {
    headerName: "Email",
    field: "email",
    width: 100,
  },
  {
    headerName: "Bank Name",
    field: "bankName",
    width: 100,
  },
  {
    headerName: "Account No",
    field: "accountNo",
    width: 120,
  },
  {
    headerName: "Credit Days",
    field: "creditDays",
    width: 100,
  },
  {
    headerName: "Credit Limit",
    field: "creditLimit",
    width: 100,
  },
  {
    headerName: "Remark",
    field: "remarks",
    width: 100,
  },
  {
    headerName: "Address",
    field: "address",
    width: 130,
  },
  {
    headerName: "State",
    field: "state",
    width: 120,
  },
  {
    headerName: "City",
    field: "city",
    width: 120,
  },
  {
    headerName: "Area",
    field: "area",
    width: 120,
  },
  {
    headerName: "Pincode",
    field: "pincode",
    width: 120,
  },
  {
    headerName: "Drug License",
    field: "drugLicense",
    width: 100,
  },
  {
    headerName: "Food License",
    field: "foodLicense",
    width: 100,
  },
  {
    headerName: "Pan Number",
    field: "panNumber",
    width: 100,
  },
  {
    headerName: "GSTIN",
    field: "gstin",
    width: 100,
  },
  {
    headerName: "GSTIN Type",
    field: "gstinType",
    width: 120,
  },
  {
    headerName: "Discount Style",
    field: "discountStyle",
    width: 100,
  },
];

export const columnDefsFunctions = {
  categoryName: {
    valueGetter: (params) => {
      if (params.data.categoryId) return params.data?.entityCategoryData?.name;
      else return "";
    },
  },

  bankName: {
    valueGetter: (params) => {
      if (params.data.bankId) return params.data?.entityBankData?.bankName;
      else return "";
    },
  },
  accountNo: {
    valueGetter: (params) => {
      if (params.data.bankId) return params.data?.entityBankData?.accountNo;
      else return "";
    },
  },
};

export const transformPayload = (data) => {
  delete data?.entityBankData;
  delete data?.entityCategoryData;
  delete data?.categoryName;
  delete data?.bankName;
  return data;
};
export const gstinTypeOptions = [
  { id: "Registered", label: "Registered" },
  { id: "Unregistered", label: "Unregistered" },
];

export const discountStructureOptions = [
  {
    id: "Platinum card holder",
    label: "Platinum card holder",
  },
  { id: "B2B customers", label: "B2B customers" },
  {
    id: "corporate customer category",
    label: "corporate customer category",
  },
];

// export const discountStyleOptions = [
//   { id: "dummy discount Style", label: "dummy discount Style" },
// ];

export const discountStyleOptions = [
  { id: "platinum_card_holder", label: "Platinum card holder" },
  { id: "b2b_customers", label: "B2B customers" },
  { id: "corporate_customer_category", label: "Corporate customer category" },
];

export const customerTypeOptions = [
  { id: "B2C", label: "B2C" },
  { id: "B2B", label: "B2B" },
];

export const initial_state_entity = {
  type: ENTITY_TAB,
  label: "Entity",
  allowMultipleTabs: false,
};
